import React from "react";
import { getParts } from "../../../../utils/helpers";
import { RenderPart } from "./RenderPart";

export const LearnStep: React.FC<any> = ({
    step,
    text,
    blanks,
    blankClick,
    noTopPaddin = false,
    textStyle = {},
    fillStyle = false,
    chatStyle = {},
    loadImageCallback,
    currentStepBlank,
    togglePlayAudio,
}) => {
    return (
        <div
            className={`flex flex-col px-4 ${
                noTopPaddin ? "" : "pt-5"
            } pb-3 mb-2 bg-milk`}
            style={
                fillStyle
                    ? {
                          flexWrap: "wrap",
                          paddingTop: "20px",
                          paddingBottom: "52px",
                          paddingLeft: "16px",
                          paddingRight: "44px",
                          marginBottom: "12px",
                          ...chatStyle,
                      }
                    : {}
            }
            onClick={() => {
                if (togglePlayAudio) togglePlayAudio();
            }}
        >
            <div className="text-base font-normal text-dark-charcoal">
                {getParts(text).map((part, pIndex) => (
                    <RenderPart
                        part={part}
                        key={pIndex}
                        blanks={blanks}
                        step={step}
                        blankClick={blankClick}
                        textStyle={textStyle}
                        loadImageCallback={loadImageCallback}
                        currentStepBlank={currentStepBlank}
                    />
                ))}
            </div>
        </div>
    );
};
